/* js/image-map-resizer.js */

;(function($, window, document) {

    $(document).on('ready', function() {

        $('map').imageMapResize();

    });

})(jQuery, window, document);